import { render, staticRenderFns } from "./StatusPeca.vue?vue&type=template&id=5501bc7b&"
import script from "./StatusPeca.vue?vue&type=script&lang=js&"
export * from "./StatusPeca.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports